import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import { Backdrop, CircularProgress, Drawer } from "@mui/material";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import { connect } from "react-redux";
import { selectLoginStatus } from "../../store/signIn/signIn.selectors";
import { selectemployeeData } from "../../store/home/home.selectors";
import { bindActionCreators } from "redux";
import { userLogin, userLoginFailure } from "../../store/signIn/signIn.actions";
import { homeSyncStart } from "../../store/home/home.actions";
import AppConfig from "../../config/app.config";

const removeExtraSpace = (s) => s.trim().replace(/\s/g, "");
var isNotification = 0;

const mapStateToProps = (state) => {
  return {
    selectLoginStatus: selectLoginStatus(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      userLogin,
      userLoginFailure,
      homeSyncStart,
    },
    dispatch
  ),
});

class SigninOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    if (this.props.employeeData?.employeeId != null) {
      this.props.close();
    } else {
      this.setState({
        username: "",
        password: "",
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectLoginStatus, userLoginFailure } = this.props;
    if (isNotification === 1) {
      if (selectLoginStatus.success != null) {
        if (selectLoginStatus.success) {
          isNotification = 0;
          NotificationManager.success("Login Successfully.", "", 2000);
          this.timeoutHandle = setTimeout(() => {
            this.setState({ isLoading: 0 });
            this.props.close();
            const payload = {
              appId: AppConfig.API.APP_ID,
              subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
              verticalId: AppConfig.API.VERTICAL_ID,
              loginEmployeeId: this.props.employeeData?.employeeId,
            };
            this.props.homeSyncStart(payload);
          }, 3000);
          userLoginFailure({ loginSuccess: false, loading: false, err: null });
        } else {
          if (selectLoginStatus.error != null) {
            NotificationManager.error(selectLoginStatus.error, "", 2000);
            isNotification = 0;
            this.timeoutHandle = setTimeout(() => {
              this.setState({ isLoading: 0 });
            }, 3000);
            userLoginFailure({
              loginSuccess: false,
              loading: false,
              err: null,
            });
          }
        }
      }
    }
  }

  handleUsernameChange = (event) => {
    this.setState({ username: removeExtraSpace(event.target.value) });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: removeExtraSpace(event.target.value) });
  };

  signIn = () => {
    const { userLogin } = this.props;
    if (this.state.username.trim() === "") {
      NotificationManager.warning("Please Enter Email.", "", 2000);
    } else if (!validator.isEmail(this.state.username)) {
      NotificationManager.warning("Please Enter Valid Email.", "", 2000);
    } else if (this.state.password === "") {
      NotificationManager.warning("Please Enter Password.", "", 2000);
    } else if (this.state.password !== "" && this.state.username !== "") {
      const payload = {
        username: this.state.username,
        password: this.state.password,
      };
      isNotification = 1;
      this.setState({ isLoading: 1 });
      userLogin(payload);
    }
  };

  handleKeyPress = (event) => {
    // look for the `Enter` keyCode
    if (event.keyCode === 13 || event.which === 13) {
      if (event.key === "Enter") {
        console.log(event.keyCode);
        this.signIn();
      }
    }
  };

  render() {
    return (
      <>
        <Modal
          enforceFocus={false}
          show={this.props.visible}
          onHide={this.props.close}
          backdrop="static"
          keyboard={false}
          centered
          id="signin-modal"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div className="mobile-registration">
            <div className="mobile-register">
              <p>Sign in</p>
              <Whiteclose className="closeicon" onClick={this.props.close} />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register-details">
                <img
                  src={require("../../assets/images/electrified-black.png")}
                  alt="logo"
                  className="black-logo"
                ></img>
                <Form.Group>
                  <label className="label">Email</label>
                  <Form.Control
                    type="text"
                    className="register-email"
                    placeholder="email"
                    value={this.state.username}
                    onChange={this.handleUsernameChange}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <label className="label" id="labels">
                    Password
                  </label>
                  <Form.Control
                    type="password"
                    className="register-email"
                    placeholder="password"
                    value={this.state.password}
                    onChange={this.handlePasswordChange}
                    onKeyPress={this.handleKeyPress}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <button
                  onClick={this.signIn}
                  type="button"
                  className="header-mob-btn"
                >
                  Sign in
                </button>
                <button
                  onClick={() => {
                    this.props.close();
                    this.props.showRegisterOverlay();
                  }}
                  type="button"
                  className="header-mob-btn"
                  id="signin-btn"
                >
                  Register
                </button>
                <p
                  onClick={() => {
                    this.props.showForgotPasswordOverlay();
                    this.props.close();
                  }}
                >
                  <span>Forgot Passsword?</span>
                </p>
              </div>
            </div>
          </div>
        </Modal>

        <Drawer
          anchor="right"
          open={this.props.visible}
          onClose={this.props.close}
          id="set-mob-drawer"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

          <div id="togglemenu-mobile">
            <div className="close-icon">
              <Whiteclose
                className="drawerclose-icon"
                onClick={this.props.close}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register">
                <p>Sign in</p>
              </div>
              <div className="mobile-registration" id="mobile-signin">
                <div className="mobile-register-details">
                  <img
                    src={require("../../assets/images/electrified-black.png")}
                    alt="logo"
                    className="black-logo"
                  />
                  <Form.Group>
                    <label className="label">Email</label>
                    <Form.Control
                      type="text"
                      className="register-email"
                      placeholder="email"
                      value={this.state.username}
                      onChange={this.handleUsernameChange}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <label className="label" id="labels">
                      Password
                    </label>
                    <Form.Control
                      type="password"
                      className="register-email"
                      placeholder="password"
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <button
                    onClick={this.signIn}
                    type="button"
                    className="header-mob-btn"
                  >
                    Sign in
                  </button>
                  <button
                    onClick={() => {
                      this.props.close();
                      this.props.showRegisterOverlay();
                    }}
                    type="button"
                    className="header-mob-btn"
                    id="signin-btn"
                  >
                    Register
                  </button>
                  <p
                    onClick={() => {
                      this.props.showForgotPasswordOverlay();
                      this.props.close();
                    }}
                  >
                    <span>Forgot Passsword?</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SigninOverlay);
